import { isBuilderChildren } from '../utils';

const getComponentProps = (child: any) => {
    if (isBuilderChildren(child)) {
        return {
            children: child?.props?.block?.children || [],
            ...(child?.props?.block?.component?.options || {}),
        };
    }

    return child?.props || {};
};

export default getComponentProps;
